import { DesktopFooter } from './DesktopFooter';
import { MobileFooter } from './MobileFooter';

export const MainFooter = (): JSX.Element => (
  <>
    <MobileFooter />
    <DesktopFooter />
  </>
);
